// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as VerifyEmailApiModel from "../api-model/VerifyEmailApiModel.bs.js";

function decodeApiModel(json) {
  return {
          recipient: json.recipient
        };
}

function execute(json) {
  var json$1 = DeccoUtils$Catalyst.resolveResult(VerifyEmailApiModel.t_decode(json), "AddSecondaryNumbeEntityMapper.re");
  return {
          recipient: json$1.recipient
        };
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
